(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputDatetimepicker', cpInputDatetimepicker);

    cpInputDatetimepicker.$inject = ['dateFormatConst', 'momentSrvc'];

    function cpInputDatetimepicker(dateFormatConst, momentSrvc) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-datetimepicker/input-datetimepicker.html',
            scope: {
                title: '@',
                object: '=',
                prop: '@',
                isRequired: '=?',
                isDisabled: '=?',
                onChange: '&?'
            },
            link: function(scope, element, attrs, controller) {
                scope.format = dateFormatConst.datetimePicker;
                scope.defaultTime = dateFormatConst.datetimePickerDefaultTime;
                scope.isOpened = false;
                scope.openPopup = openPopup;

                scope.change = change;
                scope.proxyDate = null;

                scope.dateOptions = {
                    dateDisabled: momentSrvc.disabledWeekends,
                    minDate: momentSrvc.moment(dateFormatConst.datetimePickerMin).toDate(),
                    maxDate: momentSrvc.moment(dateFormatConst.datetimePickerMax).toDate()
                };

                scope.$watch('object', function(newValue, oldValue) {
                    if (scope.object && scope.object[scope.prop]) {
                        scope.proxyDate = momentSrvc.strToDatetime(scope.object[scope.prop]);
                    }
                });

                function change() {
                    scope.object[scope.prop] = scope.proxyDate ? momentSrvc.datetimeToStr(scope.proxyDate) : null;

                    if (scope.onChange) {
                        scope.onChange();
                    }
                }

                function openPopup() {
                    scope.isOpened = true;
                }
            }
        };
    }
})();
